import { render, staticRenderFns } from "./index.vue?vue&type=template&id=037e877e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=037e877e&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=037e877e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e877e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('037e877e')) {
      api.createRecord('037e877e', component.options)
    } else {
      api.reload('037e877e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=037e877e&scoped=true", function () {
      api.rerender('037e877e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/MyBeans/index.vue"
export default component.exports